export default __webpack_public_path__ + "static/media/services_bg.128f3ec1.jpg";